import { render } from "./ProjectListComponent.vue?vue&type=template&id=9b79de52&scoped=true&ts=true"
import script from "./ProjectListComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectListComponent.vue?vue&type=script&lang=ts"

import "./ProjectListComponent.vue?vue&type=style&index=0&id=9b79de52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b79de52"]])

export default __exports__